import * as React from "react";
import {Button} from "../../elements/Button/Button";
import {Paragraph} from "../../elements/Paragraph/Paragraph";
import ReviewBreakdown from "../ReviewBreakdown/ReviewBreakdown";

const ReviewList = ({ reviews, settings }) => {

    const reviewCounts = {
        '5': 71,
        '4': 8,
        '3': 2,
        '2': 1,
        '1': 0,
    };

    const totalReviews = Object.values(reviewCounts).reduce((sum, count) => sum + count, 0);

    return (
        <div className="p-8">
            <div className={'flex flex-row justify-between'}>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">{settings.title}</h2>
                <Button type={'button-primary'} label={'Write a review'} onClick={undefined}/>
            </div>

            <Paragraph text={settings.content} />

            {/* Rating and Stats */}
            <div className="flex justify-between items-center border-b pb-6">
                <div className="flex flex-col gap-2">

                    <div className={'total-review-star-count flex flex-row gap-2'}>
                        <StarIcon key={`star-${1}`} className="text-yellow-400"/>
                        <StarIcon key={`star-${2}`} className="text-yellow-400"/>
                        <StarIcon key={`star-${3}`} className="text-yellow-400"/>
                        <StarIcon key={`star-${4}`} className="text-yellow-400"/>
                        <StarIcon key={`star-${5}`} className="text-yellow-400"/>
                    </div>

                    <div className="text-5xl font-bold text-gray-900 ml-2">4.9 <span className="text-xl text-gray-500">Based on 82 Reviews</span></div>
                    <ReviewBreakdown reviewCounts={reviewCounts} totalReviews={totalReviews} />

                </div>
                <div className="flex">
                    <div className="ml-4">
                        <div className="text-5xl font-bold text-gray-900">99%</div>
                        <div className="text-xl text-gray-500">Based on 82 Reviews</div>
                    </div>
                </div>

                <div className={'grid grid-cols-3 gap-2'}>
                    <img src="https://via.placeholder.com/50" alt="Summary Icon" className="w-20 h-20"/>
                    <img src="https://via.placeholder.com/50" alt="Summary Icon" className="w-20 h-20"/>
                    <img src="https://via.placeholder.com/50" alt="Summary Icon" className="w-20 h-20"/>
                </div>
            </div>

            {/* Review Filters */}
            <div className="my-6">
                <button className="text-gray-700 font-semibold py-2 px-4 border border-gray-300 rounded shadow">
                    Filters
                </button>
            </div>

            {/* Reviews */}
            <div className="space-y-8">
                {reviews.map((review, index) => (
                    <div key={index} className="flex border-t pt-4">
                        <img src="https://via.placeholder.com/50"
                             alt="Reviewer Thumbnail"
                             className="w-20 h-20 mr-4" />
                        <div>
                            <h5 className="text-lg font-bold">{review.author} <span className="text-sm font-normal text-gray-500">{review.date}</span></h5>
                            <div className="mt-1">{review.content}</div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Load More Button */}
            <div className="flex justify-center mt-8">
                <button className="text-gray-700 font-semibold py-2 px-4 border border-gray-300 rounded shadow">
                    Show more
                </button>
            </div>
        </div>
    );
};

function StarIcon(props) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
    )
}

export default ReviewList;
